var $ = require('@alife/alpha-jquery/jquery');
require('@alife/alpha-animation/event')($);

// based on animate.css
var ANIMATION_CLS = 'animated';
var ANIMATION_EVENT = 'animationFinished';
/**
 * @module alpha-mixin/animation
 * @mixin
 * @type {{}}
 */
function Animation() {
    this.before('_mergeInheritedAttrs', initAnimationAttrs);
}

/**
 * 执行队列动画
 * @param type
 * @returns {*}
 */
Animation.prototype.animateQueue = function (type) {
    if (!this.element) {
        throw new Error('animateQueue() must be invoked after this.element created!');
    }

    var queueElements = this.element.find('[animation]'),
        i = 0,
        animation = this.get('animation'),
        dtd = $.Deferred(),
        self = this,
        res = [],
        next = function () {
            var delay,
                queueElement,
                animationConfig;

            if (i < queueElements.length) {
                queueElement = queueElements.eq(i);
                delay = parseInt(queueElement.attr('delay'));
                animationConfig = getAnimationConfig(queueElement, animation);
                setTimeout(function () {
                    res.push(animate(queueElement, animationConfig, type));
                    i = i + 1;
                    next();
                }, delay || 100);

            } else {
                $.when.apply($, res).then(function () {
                    self.trigger(ANIMATION_EVENT, type, 'queue');
                    dtd.resolveWith(self, [type, 'queue']);
                });
            }
        };
    if(animation){
        next();
    }else{
        dtd.resolveWith(this);
    }

    return dtd.promise();
};


/**
 * 执行动画效果
 * @return {[type]} ['in'/'out']
 */
Animation.prototype.animate = function (type) {
    var animation = this.get('animation');
    if (!this.element) {
        throw new Error('animate() must be invoked after this.element created!');
    }
    return animate(this.element, animation, type, this).then(function (type) {
        this.trigger(ANIMATION_EVENT, type);
        return type;
    }.bind(this));
};

/**
 * 针对孩子节点进行动画的播放
 * @param selector
 * @param type
 * @returns {*}
 */
Animation.prototype.animateChildren = function (selector, type) {
    var animation = this.get('animation'),
        res = [],
        children,
        animationConfig = {};

    if (!this.element) {
        throw new Error('animateChildren() must be invoked after this.element created!');
    }
    children = this.element.find(selector);

    if(animation) {
        for (var i = 0; i < children.length; i++) {
            animationConfig = getAnimationConfig(children.eq(i), animation);
            res.push(animate(children.eq(i), animationConfig, type, this));
        }
    }
    return $.when.apply($, res).then(function () {
        this.trigger(ANIMATION_EVENT, type);
    }.bind(this));
};


/**
 * 组件`attrs`增加 animation 相关配置
 */
function initAnimationAttrs() {
    var attrs = this.attrs;
    /**
     * attrs.animation
     * @type {String|Object|Boolean}
     * 取值
     * false  : 没有过渡效果
     * 'fade' : 转换为 { 'in': 'fadeIn', 'out':'fadeOut'}
     * {'in':'fadeInLeft', 'out': 'fadeOutRight'} : 效果为 'fadeInLeft', 'fadeOutRight'
     */
    attrs.animation = {
        value: {
            'in': 'fadeIn',
            'out': 'fadeOut'
        },
        setter: function (val) {
            if (typeof val == 'string') {
                val = {
                    'in': val + 'In',
                    'out': val + 'Out'
                };
            }
            return val;
        },
        getter: function(val){
            if(typeof val == 'string'){
                val = {
                    'in': val + 'In',
                    'out': val + 'Out'
                };
            }
            return val;
        }
    };
}

function getAnimationConfig(el, animation){
    var animationConfig = {
        'in': el.attr('in'),
        out: el.attr('out')
    };

    if(!animationConfig['in']){
        animationConfig['in'] = animation['in'];
    }

    if(!animationConfig.out){
        animationConfig.out = animation.out;
    }
    return animationConfig;
}

function animate(el, animation, type, context) {
    type = type == 'in' ? 'in' : 'out';

    var dtd = $.Deferred();
    var cls = ANIMATION_CLS + ' ' + animation[type];


    if (animation === false) {
        dtd.resolveWith(this);
    } else {
        if (type == 'in') {
            el.off('animationend.animation.mixin')
                .one('animationend.animation.mixin', function () {
                    el.removeClass(cls);
                    dtd.resolveWith(context, [type]);
                }).emulateAnimationEnd()
                .show().addClass(cls);
        } else {
            el.off('animationend.animation.mixin')
                .one('animationend.animation.mixin', function () {
                    el.hide().removeClass(cls);
                    dtd.resolveWith(context, [type]);
                }).emulateAnimationEnd()
                .addClass(cls);
        }
    }

    return dtd.promise();
}


module.exports = Animation;
